<template>
  <el-row class="reportWrap">
    <el-col :span="5" v-for="item in list" :key="item.id" :style="{ backgroundColor: item.backgroundColor }">
      <div class="header">
        <span>{{ item.text }}</span>
        <img :src="item.img">
      </div>
      <div class="main">
        <template v-for="subItem in item.children">
          <p class="item" v-if="!subItem.hidden" :key="subItem.id" @click="toJump(subItem)">
            {{ subItem.word }}
            <i class="el-icon-arrow-right"></i>
          </p>
        </template>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    isBetaVersionAndbetaRunModelOfA: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let flag = this.isBetaVersionAndbetaRunModelOfA || false
    return {
      list: [
        {
          id: 1,
          backgroundColor: '#ff67af',
          img: require('@/assets/image/default/report/stock.png'),
          text: '库存类',
          children: [
            {
              id: 15,
              word: flag ? '主账查询' : '库房主账查询',
              path: '/templates/vue-account/dist/index.htm#/inventoryQuery'
            },
            {
              id: 17,
              word: flag ? '库存流水' : '库存流水查询',
              path: '/templates/vue-account/dist/index.htm#/inventoryQuery?tag=D'
            },
            {
              id: flag ? 245 : 11,
              idList: [11, 245],
              word: flag ? '调拨报表' : '调拨汇总查询',
              path: flag ? '/yunsierp3/index.html#/reportForms/transferReport' : '/Account/sys/InvMoveSearch/index.html'
            },
            {
              id: flag ? 300 : 19,
              idList: [19, 300],
              word: flag ? '商品补货提醒' : '库存预警查询',
              path: flag ? '/yunsierp3/index.html#/reportForms/inventoryWarn' : '/Account/sys/InvWarning/invWarningSearch.html'
            }
          ]
        },
        {
          id: 2,
          backgroundColor: '#6590ff',
          img: require('@/assets/image/default/report/sale.png'),
          text: '销售类',
          children: [
            {
              id: flag ? 213 : 27,
              idList: [27, 213],
              word: flag ? '销售数据统计报表' : '销售报表',
              path: flag ? '/templates/vue-account/dist/index.htm#/saleReportDimension' : '/Account/sys/saleCollect/indexForVue.html'
            },
            {
              id: flag ? 242 : 170,
              idList: [170, 242],
              word: '销售明细表',
              path: flag ? '/templates/vue-account/dist/index.htm#/commodityDetails' : '/Account/sys/saleDetail/index.html'
            },
            {
              id: 169,
              word: '销售-退货价格报表',
              path: '/Account/sys/salPriceReport/index.html',
              hidden: flag
            },
            {
              id: flag ? 200 : 99,
              idList: [99, 200],
              word: flag ? '订单汇总报表' : '订单配送明细表',
              path: flag ? 'templates/vue-account/dist/index.htm#/orderReport' : '/templates/vue-account/dist/index.htm#/orderReport'
            },
            {
              id: flag ? 203 : 100,
              idList: [100, 203],
              word: flag ? '业务配送汇总' : '订单配送汇总表',
              path: flag ? '/templates/vue-account/dist/index.htm#/salesmanAndDeliverCollect' : '/templates/vue-account/dist/index.htm#/orderReport'
            },
            {
              id: 168,
              idList: [168, 213],
              word: '差价汇总查询',
              path: '/Account/sys/saleDetail/discountCollect.html',
              hidden: flag
            }
          ]
        },
        {
          id: 3,
          backgroundColor: '#7e65ff',
          img: require('@/assets/image/default/report/finance.png'),
          text: '财务类',
          children: [
            {
              id: flag ? 223 : 67,
              idList: [67, 223],
              word: flag ? '客户对账' : '门店往来查询',
              path: flag ? '/templates/vue-account/dist/index.htm#/dataSearchCustomerReconciliation' : '/Account/sys/salPayBalance/index.html'
            },
            {
              id: flag ? 222 : 68,
              idList: [68, 222],
              word: flag ? '供应商对账' : '供应商往来查询',
              path: flag ? '/templates/vue-account/dist/index.htm#/dataSearchSupplierReconciliation' : '/Account/sys/purPayBalance/index.html'
            },
            {
              id: flag ? 270 : 65,
              idList: [65, 270],
              word: flag ? '费用汇总报表' : '费用汇总查询',
              path: flag ? '/yunsierp3/index.html#/reportForms/costReport' : '/Account/sys/feeSearch/feeSumSearch/indexDataSearch.html'
            },
            {
              id: 69,
              word: '业务员欠款查询',
              path: '/Account/sys/arrearCollectQuery/salesmanArrearCollect.html'
            },
            {
              id: 166,
              word: '现金银行汇总',
              path: '/Account/sys/finance/bankBusiness/bankCollectQuery.html'
            },
            {
              id: 167,
              word: '应收账款账期汇总',
              path: '/Account/sys/accountsReceivablePaymentDaysSummary/index.html'
            }
          ]
        },
        {
          id: 4,
          backgroundColor: '#ff7567',
          img: require('@/assets/image/default/report/analysis.png'),
          text: '数据分析类',
          children: [
            {
              id: 120,
              word: '拜访明细',
              path: '/Account/sys/visitAnalysisVue/index.html'
            },
            {
              id: 119,
              word: '拜访轨迹',
              path: '/Account/sys/saleManTrajectoryVue/index.html'
            },
            {
              id: 121,
              idList: [121, 322],
              word: '门店拜访预警',
              path: '/Account/sys/customerVisit/indexNew.html',
              hidden: flag
            }
          ]
        }
      ]
    }
  },
  methods: {
    toJump ({ word: text, path, id, idList = [] }) {
      idList = idList ? idList : []
      this.$emit('toJumps', { text, path, id, idList })
      // top.addPanelwithTab(text, path)
    }
  }
}
</script>

<style lang="less">
  .reportWrap {
    height: calc(100% - 15px);
    margin-top: 15px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    .el-col {
      min-height: 300px;
      max-height: 365px;
      border-radius: 16px;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      box-shadow: 0px 0px 15px 0px rgba(41, 0, 255, 0.2);
      color: #fff;
      .header {
        display: flex;
        position: relative;
        padding: 20px;
        font-size: 1.6vw;
        img {
          position: absolute;
          right: 0;
          top: 0;
          width: 30%;
          transform: translate(24%, -10%);
          opacity: 0.3;
        }
      }
      .main {
        padding-bottom: 20px;
        .item {
          padding: 10px 20px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9vw;
          &:hover {
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
</style>
